var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-pay" },
    [
      _c("div", { staticClass: "page-title" }, [_vm._v("报名缴费")]),
      _vm.orderList.length === 0
        ? _c("div", { staticClass: "pay-empty" }, [
            _c("i", {
              staticClass: "el-icon-s-order",
              staticStyle: { "font-size": "66px", color: "#c0c4cc" },
            }),
            _vm.isCharged
              ? _c(
                  "div",
                  { staticStyle: { "margin-top": "20px", color: "#909399" } },
                  [_vm._v("暂无待缴费订单")]
                )
              : _c(
                  "div",
                  { staticStyle: { "margin-top": "20px", color: "#909399" } },
                  [_vm._v("本考试不收取报名费")]
                ),
          ])
        : [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: { data: _vm.orderList },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    label: "订单号",
                    prop: "orderNo",
                    "min-width": "160",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "考试名称",
                    prop: "examName",
                    "min-width": "160",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "报考岗位",
                    prop: "postName",
                    "min-width": "120",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: { label: "订单金额(元)", "min-width": "110" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                scope.row.orderAmount != null
                                  ? (scope.row.orderAmount / 100).toFixed(2)
                                  : "-"
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "缴费状态", "min-width": "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.payStatusTagType(scope.row.payStatus),
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.payStatusLabel(scope.row.payStatus)
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "支付时间",
                    prop: "payTime",
                    "min-width": "160",
                    formatter: _vm.formatTime,
                  },
                }),
                _c("el-table-column", {
                  attrs: { label: "操作", "min-width": "100", fixed: "right" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.payStatus === 0
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "mini",
                                    loading: _vm.payingId === scope.row.id,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handlePay(scope.row)
                                    },
                                  },
                                },
                                [_vm._v(" 去支付 ")]
                              )
                            : scope.row.payStatus === 1
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "success",
                                    size: "mini",
                                    disabled: "",
                                  },
                                },
                                [_vm._v(" 已支付 ")]
                              )
                            : _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "info",
                                    size: "mini",
                                    disabled: "",
                                  },
                                },
                                [_vm._v(" 已退费 ")]
                              ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("div", { staticClass: "pay-tip" }, [
              _vm._v('提示：请确认报名信息无误后点击"去支付"完成缴费。'),
            ]),
          ],
      _c(
        "el-dialog",
        {
          attrs: {
            title: "扫码支付",
            visible: _vm.qrVisible,
            width: "380px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.qrVisible = $event
            },
            closed: _vm.clearQrcode,
          },
        },
        [
          _c("div", { staticClass: "qr-content" }, [
            _c("div", { staticClass: "qr-box" }, [
              _c("canvas", {
                ref: "qrCanvas",
                staticStyle: { width: "240px", height: "240px" },
              }),
              _vm.qrLoading
                ? _c("div", { staticClass: "qr-loading" }, [
                    _vm._v("二维码生成中..."),
                  ])
                : _vm._e(),
            ]),
            _vm.payOrder
              ? _c("div", { staticClass: "qr-amount" }, [
                  _vm._v(" 应付金额："),
                  _c("span", { staticClass: "amount" }, [
                    _vm._v(_vm._s((_vm.payOrder.orderAmount || 0) / 100)),
                  ]),
                  _vm._v(" 元 "),
                ])
              : _vm._e(),
            _c("div", { staticClass: "qr-tip" }, [
              _vm._v(
                " 请用微信或支付宝扫码支付，支付完成后请稍候片刻查询缴费状态。 "
              ),
            ]),
            _c("div", { staticClass: "qr-once-tip" }, [
              _c("i", { staticClass: "el-icon-warning-outline" }),
              _vm._v(" 该二维码仅可扫码一次，请扫码后尽快完成支付 "),
            ]),
          ]),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.qrVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.qrRefreshing,
                  },
                  on: { click: _vm.refreshQrcode },
                },
                [_vm._v("刷新二维码")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }